const api = {
  apiUrl: "",
  apiImages: "",
  apiPath: "/engine/ajax.php?type=react",
  // apiUrl: "https://rpmserver.com",
  // apiImages: "https://rpmserver.com",
  // apiPath: "https://rpmserver.com/engine/ajax.php?type=react",
};

export default api;